.comma-separator:not(:last-child)::after {
  content: ',';
  padding-right: 0.5em;
}

.min-width-150px {
  min-width: 150px;
}

.draggable {
  &:hover,
  &:focus-within {
    button {
      opacity: 1 !important;
    }
  }

  .nav-link {
    border-right: none;
    padding-right: 0rem;

    button {
      opacity: 0;
    }
  }

  .drag-handle {
    padding-right: 0.5rem;
    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
  }

  .cursor-grab {
    cursor: grab;
  }

  &.active > .drag-handle {
    border: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
    border-bottom: none;
    border-left: none;
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  }
}
